import { parseAttributesToArray } from '@cart-services/parser/parseAttributes'
import { type AttributesObject } from '@hooks-api/types/dataModel/products'

export const getProductName = (title?: string, attributes?: AttributesObject) => [title, ...(parseAttributesToArray(attributes ?? {}) || [])].join(' | ')
